import { getRatesCityByIdRequest } from "../../data/ratesCityApi";

function getPayloadData(response) {
  return response?.data?.data || response?.data || null;
}

export async function getTarifaCityByIdUseCase(id) {
  if (!id) {
    throw new Error("El id de la tarifa de ciudad es obligatorio.");
  }

  return getPayloadData(await getRatesCityByIdRequest(id));
}
